import { render, staticRenderFns } from "./OfficeCustomizationForm.vue?vue&type=template&id=3903fd16"
import script from "./OfficeCustomizationForm.vue?vue&type=script&lang=js"
export * from "./OfficeCustomizationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports